import React from "react";
import { useNavigate } from "react-router-dom";

// Utility fallback for avatar
const generateAvatar = (name = "") => {
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`;
};

const SellerInfoCard = ({ logo, name, cname, address, uid }) => {
  const navigate = useNavigate();
  const hasLogoOrName = !!(logo?.image || name);

  return (
    <div
      className="mt-2 mb-2"
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        overflow: "hidden",
      }}
    >
      {/* Heading */}
      <h5 className="main-heading-style py-1 mb-2">Seller</h5>

      {/* Content Section */}
      <div
        className={`d-flex flex-wrap align-items-center ${
          hasLogoOrName ? "justify-content-between" : "justify-content-center"
        }`}
      >
        <div
          className={`d-flex align-items-center ${
            !hasLogoOrName ? "justify-content-center w-100 text-center" : ""
          }`}
        >
          {/* Logo */}
          {hasLogoOrName && (
            <div
            style={{
              position: "relative",
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              overflow: "hidden",
              border: "3px solid #4f97a1",
              backgroundColor: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "15px",
            }}
          >
            <img
              src={logo?.image || generateAvatar(name)}
              alt="Company Logo"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "50%",
                display: "block",
                maxHeight: "90px",
              }}
            />

          </div>

          )}

          {/* Seller Info */}
          <div className="seller-info">
            {cname && (
              <p
                style={{
                  fontSize: "16px",
                  color: "#1D1D1D",
                  fontWeight: 500,
                  marginBottom: "5px",
                }}
              >
                {cname}
              </p>
            )}

            {address && (
              <p
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: 0,
                }}
              >
                {address}
              </p>
            )}

            <p className="mt-1">
              <button
                onClick={() => navigate(`/companydetail/${uid}/${cname || ""}`)}
                className="btn btn-sm"
                style={{
                  backgroundColor: "#1A78B4",
                  color: "#fff",
                  fontWeight: 500,
                  fontSize: "12px",
                }}
              >
                Visit Estore
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerInfoCard;
